import { Box, BoxProps, Text, TextProps } from "@chakra-ui/react";
import React, { ForwardedRef } from "react";

export interface SearchSuggestionProps extends BoxProps {
  label: string;
  labelProps?: TextProps;
}
export const SearchSuggestion = React.forwardRef(
  (
    { label, labelProps, ...props }: SearchSuggestionProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    return (
      <Box
        bg="white"
        borderRadius="md"
        py="4"
        _hover={{
          bg: "blueGray.100",
        }}
        _selected={{
          bg: "blueGray.100",
        }}
        {...props}
        role="option"
        ref={ref}
      >
        <Text px="4" {...labelProps}>
          {label}
        </Text>
      </Box>
    );
  },
);
